var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationCircleSolid = function SvgExclamationCircleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 12c0 6.422-5.205 11.625-11.625 11.625S.375 18.422.375 12C.375 5.582 5.58.375 12 .375S23.625 5.582 23.625 12M12 14.344a2.156 2.156 0 1 0 0 4.312 2.156 2.156 0 0 0 0-4.312m-2.047-7.75.348 6.374a.563.563 0 0 0 .561.532h2.276a.563.563 0 0 0 .562-.532l.347-6.375A.563.563 0 0 0 13.485 6h-2.97c-.323 0-.58.27-.562.593"
  })));
};
export default SvgExclamationCircleSolid;